import React from "react";
import { ReactComponent as Arrows } from "./arrows.svg";
import { useSelector } from "react-redux";
import { getShowSpinHint } from "../../redux/selectors";
import { Fade } from "../Fade/Fade";

function SpinHint() {
  const show = useSelector(getShowSpinHint);
  return (
    <Fade
      isVisible={show}
      style={{
        pointerEvents: "none",
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        bottom: 0,
        padding: "8px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Arrows id="hse-spin-hint-arrows" width="" height="" />
    </Fade>
  );
}

export default SpinHint;
